import { useState } from 'react';

import type { DashboardCardProps } from '@/features/Dashboard/components/DashboardCard';
import DashboardCardShell from '@/features/Dashboard/components/DashboardCardContent/DashboardCardShell';
import DashboardCardStyles from '@/features/Dashboard/components/styles/DashboardCardStyles';
import useDashboardCardDrag from '@/features/Dashboard/hooks/useDashboardCardDrag';
import useDashboard2Store from '@/stores/Dashboard2Store';

import { useFeedbackGalleryActions } from '../hooks';
import { DEFAULT_FEEDBACKS_SETTING } from '../model/constants';
import FeedbackGalleryEdit from './feedback-gallery-edit';
import FeedbackGalleryHeaderActions from './feedback-gallery-header-actions';
import FeedbackGalleryView from './feedback-gallery-view';

const { StyledDashboardCardWrapper, StyledDashboardCard } = DashboardCardStyles;

const DashboardFeedbackGallery = (props: DashboardCardProps) => {
  const feedbacksSetting =
    props.column.feedbacks_setting || DEFAULT_FEEDBACKS_SETTING;
  const setEditingState = useDashboard2Store((state) => state.setEditingState);
  const globalFilter = useDashboard2Store((state) => state.globalFilter);
  const globalDateFilter = useDashboard2Store(
    (state) => state.globalDateFilter,
  );
  const [editMode, setEditMode] = useState(!props.column.id); // 신규 생성시 바로 edit 모드

  const { dragRef, previewRef, isDragging } = useDashboardCardDrag({
    index: props.index,
    rowIndex: props.rowIndex,
    setSomeDragging: props.setSomeDragging,
    column: props.column,
    rowId: props.rowId,
  });

  const handleEditMode = (state: boolean) => {
    setEditMode(state);
    setEditingState(state);
  };

  const { onDone, onDelete, onDuplicate, onClickAskSyncly } =
    useFeedbackGalleryActions({
      dashboardId: props.dashboardId,
      rowId: props.rowId,
      rowIndex: props.rowIndex,
      columnId: props.column.id,
      feedbacksSetting,
      globalFilter,
      globalDateFilter,
      onEditModeChange: handleEditMode,
    });

  const handleCancel = () => {
    handleEditMode(false);
  };

  if (editMode) {
    return (
      <StyledDashboardCardWrapper isDragging={false} width={props.width}>
        <StyledDashboardCard className="h-full">
          <FeedbackGalleryEdit
            feedbacksSetting={feedbacksSetting}
            columnId={props.column.id}
            onDone={onDone}
            onCancel={handleCancel}
            onDelete={onDelete}
            globalFilter={globalFilter}
            globalDateFilter={globalDateFilter}
          />
        </StyledDashboardCard>
      </StyledDashboardCardWrapper>
    );
  }

  return (
    <DashboardCardShell
      previewRef={previewRef}
      dragRef={dragRef}
      isDragging={isDragging}
      width={props.width}
      wrapperClassName="h-full"
    >
      <FeedbackGalleryView
        feedbacksSetting={feedbacksSetting}
        columnId={props.column.id}
        globalFilter={globalFilter}
        globalDateFilter={globalDateFilter}
        onTitleClick={() => {
          handleEditMode(true);
        }}
        headerAction={
          <FeedbackGalleryHeaderActions
            onClickAskSyncly={onClickAskSyncly}
            onDuplicate={onDuplicate}
            onDelete={onDelete}
          />
        }
      />
    </DashboardCardShell>
  );
};

export default DashboardFeedbackGallery;

